import {
    useQuery,
  } from '@tanstack/react-query'
import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { getMe } from '@jconradi/tutu-porn-api-client/src/me';

export const useMe = () => {
    const { isLoggedIn } = useContext(AuthContext);

    const query = useQuery({
        queryKey: ['me'],
        queryFn: getMe,
        enabled: isLoggedIn,
        useErrorBoundary: true
    });

    return query;
}